import React, { useState } from "react";
import { useStudyTimeTracker } from "../../hooks/useStudyTimeTracker";

export function StudyTimeWidget({ currentStudent }) {
  const { formatado, ativo } = useStudyTimeTracker(currentStudent?.id);
  const [visivel, setVisivel] = useState(false);

  if (!currentStudent?.id) return null;

  const mostrarTempo = () => setVisivel(true);
  const ocultarTempo = () => setVisivel(false);

  return (
    <div
      style={{
        position: "fixed",
        top: 8,
        right: 8,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 5,
        background: "rgba(31,71,84,0.92)",
        color: "#EAF3F5",
        fontSize: 11,
        fontWeight: 700,
        padding: "4px 4px 4px 9px",
        borderRadius: 999,
        boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
        letterSpacing: ".02em",
      }}
      title="Tempo estudado hoje"
    >
      <span style={{ opacity: ativo ? 1 : 0.45 }}>⏱</span>

      <span style={{ color: ativo ? "#4FB3A9" : "#8FA5AC", minWidth: 45 }}>
        {visivel ? formatado : "••••"}
      </span>

      <button
        onClick={() => (visivel ? ocultarTempo() : mostrarTempo())}
        style={{
          background: "transparent",
          border: "none",
          padding: 4,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8FA5AC",
          borderRadius: "50%",
          transition: "color 0.2s",
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          userSelect: "none",
          outline: "none",
        }}
        title="Segure para ver o tempo"
      >
        {visivel ? (
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        ) : (
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
            <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
            <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
            <line x1="2" y1="2" x2="22" y2="22" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default StudyTimeWidget;
